module.exports = __webpack_public_path__ + "static/big-green-circle-img-aae1a77ad0957ff6d9d8ea804ba660aa.png";